import React from "react";
import { useTranslation } from "react-i18next";

export function DropIndicator({ label }: { label?: string }) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t("Drop here");

  return (
    <div className={"email-builder-drop-indicator"} aria-hidden>
      <span className={"email-builder-drop-indicator__rule"} />
      <span className={"email-builder-drop-indicator__pill"}>{resolvedLabel}</span>
    </div>
  );
}
